import React from 'react';
import Button from '../ui/Button';
import { motion } from 'framer-motion';
import { FaUser, FaCalendarAlt, FaGlobe, FaVenusMars } from 'react-icons/fa';
import styles from './Step3PersonalInfo.module.css';
import { useTranslation } from 'react-i18next';

const stepVariants = {
  hidden: { opacity: 0, x: 100 },
  visible: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -100 },
};


const countries = [
	"United States", "United Kingdom", "Canada", "Germany", "France",
	"Australia", "India", "Japan", "South Korea", "Brazil", "Nigeria"
];

const Step3PersonalInfo = ({ nextStep, prevStep, setFormData, formData }) => {
    const { t } = useTranslation();
  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
	  <>
      <h2 className={styles.stepTitle}>Personal Information</h2>

      {/* Full Name */}
      <div className={styles.inputGroup}>
        <label htmlFor="fullName">
          <FaUser className={styles.icon} />
          Full Name
        </label>
        <input
          type="text"
          id="fullName"
          name="fullName"
          placeholder="Your full name"
          className={styles.inputField}
          value={formData.fullName || ''}
          onChange={handleChange}
        />
        <small className={styles.helperText}>This helps us personalize your experience. Optional.</small>
      </div>

      {/* Date of Birth */}
      <div className={styles.inputGroup}>
        <label htmlFor="dob">
          <FaCalendarAlt className={styles.icon} />
          Date of Birth
        </label>
        <input
          type="date"
          id="dob"
          name="dob"
          className={styles.inputField}
          value={formData.dob || ''}
          onChange={handleChange}
          required
        />
        <small className={styles.helperText}>You must be at least 13 years old to register.</small>
      </div>

      {/* Gender */}
      <div className={styles.inputGroup}>
        <label htmlFor="gender">
          <FaVenusMars className={styles.icon} />
          Gender
        </label>
        <select
          name="gender"
          id="gender"
          className={styles.inputField}
          value={formData.gender || ''}
          onChange={handleChange}
        >
          <option value="">Select (Optional)</option>
          <option value="female">Female</option>
          <option value="male">Male</option>
          <option value="nonbinary">Non-binary</option>
          <option value="preferNotToSay">Prefer not to say</option>
        </select>
        <small className={styles.helperText}>This is optional and helps us with demographics.</small>
      </div>

      {/* Location */}
      <div className={styles.inputGroup}>
        <label htmlFor="location">
          <FaGlobe className={styles.icon} />
          Location
        </label>
		<select  className={styles.inputField} id="location" name="location" placeholder="City, Country (Optional)" value={formData.location || ''} onChange={handleChange}>
		  <option value="">{t('profile.select')}</option>
		  {countries.map(c => <option key={c} value={c}>{c}</option>)}
		</select>
        <small className={styles.helperText}>We use this to tailor debate topics and timings.</small>
      </div>

      <div className={styles.navbuts}>
        <Button variant="secondary" className={styles.prevButton} onClick={prevStep}>Back</Button>
        <Button variant="primary" className={styles.nextButton} onClick={nextStep}>Next</Button>
      </div>
	  </>
  );
};

export default Step3PersonalInfo;